// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue14(props) {
    return (
        <svg
            id="_x31_4"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
            style={{
                enableBackground: 'new 0 0 250 250',
            }}
            xmlSpace="preserve"
            {...props}
        >
            <style type="text/css">
                {
                    "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n\t.st11{display:none;}\n\t.st12{display:inline;}\n\t.st13{font-size:4.995px;}\n\t.st14{fill:none;stroke:#B3B3B3;stroke-miterlimit:3.92;}\n\t.st15{fill:none;stroke:#B7B7B7;}\n\t.st16{fill:none;stroke:#B3B3B3;stroke-width:0.25;stroke-miterlimit:10;}\n"
                }
            </style>
            <g id="TOR">
                <g id="compass">
                    <path
                        className="st0"
                        d="M226.9,208.5l-1.5-9.1l1.6-7.8l1.6,7.8L226.9,208.5z"
                    />
                    <path
                        className="st1"
                        d="M227.1,215c-8.6,0-15.5-6.9-15.5-15.5s6.9-15.5,15.5-15.5s15.5,6.9,15.5,15.5C242.5,208,235.6,215,227.1,215z  M227,185.3c-7.8,0-14.2,6.4-14.1,14.2c0,7.8,6.4,14.2,14.2,14.1c7.8,0,14.2-6.4,14.1-14.2C241.2,191.7,234.8,185.3,227,185.3z"
                    />
                    <path
                        className="st0"
                        d="M229.1,197.4c1.2,1.2,1.2,3,0,4.2s-3,1.2-4.2,0s-1.2-3,0-4.2C226.1,196.3,227.9,196.3,229.1,197.4z  M225.8,190.3v-3.1h0.5l1.4,2.1v-2.1h0.5v3.1h-0.5l-1.4-2.1v2.1H225.8z"
                    />
                    <path
                        className="st2"
                        d="M228.2,198.4c0.6,0.6,0.6,1.7,0,2.3s-1.7,0.6-2.3,0s-0.6-1.7,0-2.3C226.5,197.7,227.5,197.7,228.2,198.4z"
                    />
                </g>
                <g id="distances">
                    <text
                        id="right"
                        transform="matrix(1 0 0 1 224.0186 113.4121)"
                        className="st3 st4 st5"
                    >
                        328
                    </text>
                    <text
                        id="right-center_1_"
                        transform="matrix(1 0 0 1 178.751 51.9463)"
                        className="st3 st4 st5"
                    >
                        375
                    </text>
                    <text
                        id="center_1_"
                        transform="matrix(1 0 0 1 116.1396 33.0791)"
                        className="st3 st4 st5"
                    >
                        400
                    </text>
                    <text
                        id="left-center_1_"
                        transform="matrix(1 0 0 1 54.8125 52.1807)"
                        className="st3 st4 st5"
                    >
                        375
                    </text>
                    <text
                        id="left"
                        transform="matrix(1 0 0 1 7.8335 113.4126)"
                        className="st3 st4 st5"
                    >
                        328
                    </text>
                </g>
                <g id="field">
                    <path
                        id="Outfield_00000139263571581690122010000007572633505411225276_"
                        className="st6"
                        d="M28.6,106.5l1.7-1.6l1.6-1.7l1.7-1.7 l1.7-1.7l1.7-1.7l1.7-1.7l1.7-1.7l1.6-1.9l1.6-1.9l1.6-2l1.6-2l1.6-2l1.7-2l1.4-2.4L53,78l1.5-2.5L56,73l1.6-2.6l1.8-2.2l2-1.9 l2-2l2-2l2-2l2.1-2l2.1-2l2.2-2.1l2.2-2.1l2.5-1.2l2.6-1.1l2.6-1l2.6-1l2.6-1.1l2.6-1.1l2.7-1.1l2.7-1.1l2.7-1.1l2.7-1.1l2.7-1.1 l2.8-1l2.8-1l2.8-0.7l2.9-0.4l2.9-0.4l2.9-0.2h2.9h2.9l2.9,0.2l2.9,0.4l2.9,0.4l2.8,0.8l2.8,0.9l2.8,1l2.7,1.2l2.7,1.3l2.7,1.3 l2.6,1.3l2.6,1.2l2.6,1.2l2.6,1.2L166,50l2.5,1.2l2.4,1.6l2.2,2.2l2.1,2.2l2.1,2.2l2,2.1l2,2.1l2,2l2,2l1.9,2l2,1.8l2,1.7l2,1.7 l2,1.7l2,1.5l2.1,1.3l2.2,1.3l2.1,1.3l2.1,1.3l1.5,2.2l1.5,2.2l1.5,2.1l1.5,2.1l1.5,2.1l1.5,2l1.5,2.1l1.4,2l1.4,2l1.4,2l1.4,2 l0.5,0.8c0,0-7.3,7.6-8.9,9.1c-1.6,1.5-3,2.3-4.8,5.2c-1.9,2.9-3,5.7-4.3,8.3s-4.8,10.4-6.2,13.7s-3.9,8.3-5.2,10.4 c-1.3,2.1-5.6,9.2-7.5,12.3s-9.2,13.6-11.6,16.5c-2.4,3-8.9,11.2-8.9,11.2s-2.6,3.4-3.5,4.9l-4.3,5.7l0.5,0.9c0,0-7,6.5-8.2,7.5 c-1.1,0.9-4.2,3.3-4.2,3.3l-0.8-0.8c-4.2,2.7-7.2,4.8-10,5.4s-2.3,0.8-4.2,0.8s-9.6,0-11.6,0s-8.9-3.4-10.1-4.1l-1,0.7 c0,0-7.2-5.7-9-7.4s-6.2-5.1-6.2-5.1l0.5-0.8c0,0-2.7-4.1-3.6-5.4s-3.1-4.4-3.1-4.4s-0.7-0.8-2.1-2.3s-7.2-9.4-9.7-12.4 c-2.4-3-3.8-5.4-6.4-9.2s-5.3-8.7-7.3-12.2s-5.3-9.4-7.2-13.1c-1.9-3.7-3.9-8.6-4.8-11.2c-0.9-2.6-4.2-8.9-4.9-10.2 c-0.7-1.3-1.8-3.4-3.2-5.1c-1.4-1.6-12.1-12.8-12.1-12.8L28.6,106.5z"
                    />
                    <path
                        id="grass_00000174589876715782793730000007613552633814403240_"
                        className="st3"
                        d="M190.9,144.1c-2.6,4.8-13.4,22.5-16,25.8 c-2.7,3.3-16,19.3-19,23.1s-11,14.3-14.3,16.9c-3.3,2.6-9.6,6.4-11.9,6.4c-2.3,0-6.6,0-9.3,0c-2.7,0-11.5-5.1-14.6-7.4 c-3.2-2.3-6.6-5.2-9.3-8.7c-2.7-3.6-9-13.2-12.4-17.3S73.7,169,70.4,164.2c-3.3-4.8-11.5-20.6-13-23.9c-1.5-3.4-6.8-14.8-7.6-16.5 s-3.7-6.2-3.7-6.2s-0.9-1.8-1.9-3.1c-1-1.3-6.1-6.8-6.1-6.8s5.2-4.7,7.6-7.3s10.2-12.7,11.9-14.9S64,73.1,66.4,71 c2.4-2.2,12.1-11.7,15.4-13.5s12.1-5.6,16.3-7.2c4.2-1.6,17.3-7.1,19.8-7.1s10.8,0,14.9,0c4.1,0,29.2,12.9,32.4,15.3 s7.8,7,10.1,9.9s12.3,12.3,15,14.5s6.9,4.2,8.9,5.9c2,1.7,13.7,18.7,13.7,18.7l-9.2,9.4l-1.9,2.7 C201.9,119.4,197.6,131.9,190.9,144.1z"
                    />
                    <path
                        id="infield_sand"
                        className="st6"
                        d="M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
                    />
                </g>
                <g id="persistent_1_">
                    <g id="mound_1_">
                        <path
                            id="pitching-mound_1_"
                            className="st6"
                            d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
                        />
                        <path
                            id="pitching-rubber_1_"
                            className="st7"
                            d="M123.2,176.6h4v1.6h-4V176.6z"
                        />
                    </g>
                    <g id="lines_1_">
                        <path
                            id="left-foul-line_1_"
                            className="st8"
                            d="M125.2,203.2l-97.1-97.1"
                        />
                        <path
                            id="right-foul-line_1_"
                            className="st8"
                            d="M125.2,203.2l97.1-97.2"
                        />
                    </g>
                    <g id="bases_2_">
                        <rect
                            id="third-base_2_"
                            x={99.2}
                            y={175.1}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="first-base_2_"
                            x={148.1}
                            y={175.2}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="second-base_2_"
                            x={123.7}
                            y={148.6}
                            transform="matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)"
                            className="st10"
                            width={3}
                            height={3}
                        />
                        <polygon
                            id="home_2_"
                            className="st7"
                            points="126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
                        />
                    </g>
                </g>
            </g>
            <g id="grid" className="st11">
                <g className="st12">
                    <g id="numbers">
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 90.9866 184.0761)"
                            className="st4 st13"
                        >
                            90
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 56.4654 153.8222)"
                            className="st4 st13"
                        >
                            200
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 71.0452 168.4018)"
                            className="st4 st13"
                        >
                            150
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 80.378 177.7343)"
                            className="st4 st13"
                        >
                            120
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 41.6028 138.9599)"
                            className="st4 st13"
                        >
                            250
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 27.4712 123.956)"
                            className="st4 st13"
                        >
                            300
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 12.6905 109.1753)"
                            className="st4 st13"
                        >
                            350
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 75.9258)"
                            className="st4 st13"
                        >
                            400
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 49.4311)"
                            className="st4 st13"
                        >
                            450
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 24.6201)"
                            className="st4 st13"
                        >
                            500
                        </text>
                    </g>
                    <g id="surface29_2_">
                        <path className="st14" d="M125.5,203.8l-148-148" />
                        <path className="st14" d="M124.8,203.8l148-148" />
                        <path className="st15" d="M125.1,203.5L45.4,10.9" />
                        <path className="st15" d="M125.1,203.5V-4.9" />
                        <path className="st15" d="M125.1,203.5l79.8-192.6" />
                    </g>
                    <path
                        id="_x31_00-line"
                        className="st14"
                        d="M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
                    />
                    <path
                        id="_x32_00-line_2_"
                        className="st14"
                        d="M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5c23,0,43.8,9.3,58.8,24.4"
                    />
                    <path
                        id="_x39_0-line_2_"
                        className="st14"
                        d="M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1c10.4,0,19.7,4.2,26.5,11"
                    />
                    <path
                        id="_x31_20-line"
                        className="st14"
                        d="M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4c17.2,0,32.8,7,44.1,18.3"
                    />
                    <path
                        id="_x32_50-line"
                        className="st14"
                        d="M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6c28.7,0,54.7,11.6,73.6,30.5"
                    />
                    <path
                        id="_x33_00-line"
                        className="st14"
                        d="M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
                    />
                    <path
                        id="_x33_50-line"
                        className="st14"
                        d="M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1c40.2,0,76.6,16.3,103,42.7"
                    />
                    <path
                        id="_x34_50-line"
                        className="st14"
                        d="M-7.4,70.9c33.9-34,80.8-55,132.6-55c51.7,0,98.6,21,132.5,54.9"
                    />
                    <path
                        id="_x34_00-line_1_"
                        className="st14"
                        d="M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9c46,0,87.6,18.6,117.7,48.8"
                    />
                    <path
                        id="_x35_00-line"
                        className="st14"
                        d="M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9c57.5,0,109.5,23.3,147.2,61"
                    />
                </g>
                <g className="st12">
                    <rect
                        x={125.2}
                        y={16}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={18}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={20.1}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={22.2}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={24.3}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={26.3}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={28.4}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={30.5}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={32.6}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        x={125.2}
                        y={34.6}
                        className="st16"
                        width={4.9}
                        height={2.1}
                    />
                </g>
            </g>
        </svg>
    )
}
export default Venue14
